import * as React from 'react';
import Grid from '@mui/material/Grid';
import { Container, Link, Typography } from '@mui/material';
const footers = [
    {
      title: 'Empresa',
      description: [ {name:'Acerca de nosotros', to:'/about-us'}, 
        {name:'Contactanos',to:'/contact-us'},{name:'Noticias',to:'/news'}],
    },
    {
      title: 'Ayuda',
      description: [
        {name:'Seguiridad y acceso',to:'/security'},
        {name:'Chatea con nosotros',to:'/chat'}
      ],
    },
    {
      title: 'Product',
      description: [{name:'Servicios',to:'/services'}, {name:'Preguntas frecuentes',to:'/faq'}],
    },
    {
      title: 'Legal',
      description: [{name:'Politica de privacidad', to:'/privacy'}, {name:'Terminos de uso',to:'/terms'}],
      to:"/privacy"
    },
];

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" mt={1}>
      {'Copyright © '}
      <Link href="https://www.cardexmedico.com">cardexmedico&nbsp;</Link>
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
    return (
        <Container
            maxWidth="md"
            component="footer"
            sx={{
              borderTop: (theme) => `1px solid ${theme.palette.divider}`,
              mt: 8,
              py: [3, 6],
            }}
          >
          <Grid container spacing={4} justifyContent="cespace-evenly">
            {footers.map((footer) => (
                <Grid item xs={6} sm={3} key={footer.title}>
                    <Typography variant="h6" gutterBottom >
                    {footer.title}
                    </Typography>
                    <ul>
                    {footer.description.map((item) => (
                        <li key={item}>
                        <Link href={item.to} variant="caption" color="text.secondary">
                            {item.name}
                        </Link>
                        </li>
                    ))}
                    </ul>
                </Grid>
            ))}
          </Grid>
          <Copyright sx={{ mt: 5 }} />
        </Container>
    );
}